module.exports = __webpack_public_path__ + "static/img/deal_14.ab1f34a4.png";